import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { PortalAncillaryBundle, PortalBundledAncillary } from '@app/services/api/api.types';

@Component({
  selector: 'disruption-protection-modal',
  templateUrl: './disruption-protection-modal.component.html',
  styleUrl: './disruption-protection-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DisruptionProtectionModalComponent {
  @Input() disruptionProtectionAncillary?: PortalBundledAncillary;
  @Input() ancillaryBundle?: PortalAncillaryBundle;

  @Output() hideModal = new EventEmitter();
  @Output() upsellDisruptionProtectionContinue = new EventEmitter();
  @Output() upsellDisruptionProtectionNext = new EventEmitter();

  sections = [
    {
      title: 'If your flight is delayed or canceled:',
      items: [
        {
          icon: 'travel_orange',
          label: 'You’ll need to deal with the airline yourself',
        },
        {
          icon: 'plane_orange',
          label: 'New flights may cost more',
        },
        {
          icon: 'travel_orange',
          label: 'Refunds can take weeks',
        },
      ],
    },
    {
      title: 'Add Premium Disruption Assistance to:',
      items: [
        {
          icon: 'travel_green',
          label: 'Get rebooked on the best available flight',
        },
        {
          icon: 'travel_i_green',
          label: 'Avoid paying out of pocket',
        },
        {
          icon: 'support',
          label: 'Get help 24/7 instead of dealing with airlines',
        },
      ],
    },
  ];
}
